const colors = {
  low: 'rgb(148,236,255)',
  ok: 'rgb(123,247,85)',
  maintain: 'rgb(69 141 47)',
  warning: 'rgb(243,220,49)',
  trip: 'rgb(218,41,28)',
  border: 'rgb(60,60,60)',
  needle: 'rgb(255,255,255)'
}

if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
  colors.border = 'rgb(220,220,220)';
  colors.needle = 'rgb(24,24,24)';
}

/*
  TODO
  - If trip is 0 things break
  - Animate needle?
*/

/**
 * @function Gauge
 * @memberof module:CircuitGauges
 *
 * @param {object} props
 * @param {number} props.size Diameter in pixels (optional)
 * @param {number} props.arc Size of the full range in degrees (optional)
 * @param {object} props.model {high, low, trip, current, power}
 * @param {string} props.unit Unit of measurement to display (e.g. °C)
 * @returns {ReactElement}
 *
 * @example
 * const model = {low: 20, high: 100, trip: 120, current: 70};
 * return (
 *  <Gauge
 *    model={model}
 *    unit={'°C'}
 *  />
 * );
 */
function Gauge({size=240, arc=270, model, unit, className=''}) {
  /*
    HACK ALERT
    This accounts for mis-configured alarms
    DELETE ME (probably)
    The low one might should stay since it seems like low ground current
    isn't really a thing
  */
  if (model.trip == 0 || isNaN(model.trip)) model.trip = model.high + 15;
  if (!model.low || isNaN(model.low)) model.low = 0;
  /* / */
  const strokeWidth = 15;
  const radius = size/2;
  // circumference in pixels
  const circumference = 2 * radius * Math.PI;
  // Pixels per 1 degree of rotation
  const degree = circumference/360;
  // Our high and low settings are going to be a fixed width (degrees)
  const boundaryWidth = 15;
  // availableArc is the arc minus our fixed boundary ranges (degrees)
  const availableArc = arc - (boundaryWidth * 2);
  // total is the discreet range from our low alarm and trip
  const total = model.trip - model.low;
  // increment is the degrees of available arc that accounts for 1 "unit" of our total
  const increment = availableArc/total;

  // NOTE - Not sure if this makes sense (defaulting to 0) but it
  // prevents the ranges from misbehaving
  const okRange = !+model.high ? 0 : model.high - model.low;
  const warningRange = !+model.high ? 0 : model.trip - model.high;

  // This creates a series of ticks along the gauge with a gap at the
  // bottom. There might be a savvier way to do it but this seems to work.
  function calculateTicks() {
    let fill = arc * degree;
    const gap = (360 - arc) * degree + 6;
    let ticks = `0 ${gap - 6} 2 4`;

    while (fill > 0) {
      ticks = ticks + ` 2 4`;
      fill = fill - 6;
    }

    return ticks;
  }

  function currentValue() {
    // Start at the low alarm
    const initial = 270 - arc/2 + boundaryWidth;
    // Calculate our offset (minus 1 to account for the needle's width)
    const needleOffset = (model.current - model.low)*increment - 1;
    // The low and trip ranges are a fixed width so we basically
    // just want the needle to top or bottom out and not go further
    const min = 270 - arc/2;
    const max = 270 + arc/2;
    return Math.max(Math.min(initial + needleOffset, max), min);
  }

  // console.log(model, circumference, degree, increment, total, availableArc);
  return (
    <div className={`circuit-gauge ${className}`} style={{width: size, height: size}}>
      <svg>
        {/* Bezel */}
        <circle
          r={radius}
          cx="50%"
          cy="50%"
          fill="none"
          stroke={colors.border}
          strokeWidth="3"
        ></circle>
        <circle
          r={radius}
          cx="50%"
          cy="50%"
          fill="none"
          stroke={colors.border}
          strokeWidth={strokeWidth * 2.5}
          strokeDasharray={calculateTicks()}
          transform={`rotate(${(arc - 180)/2} ${radius} ${radius})`}
        ></circle>
        {/* / */}

        {/* Ranges */}
        {model && !isNaN(model.high) ? <>
          <circle
            r={radius}
            cx="50%"
            cy="50%"
            fill="none"
            stroke={colors.low}
            strokeWidth={strokeWidth}
            strokeDasharray={`${boundaryWidth * degree} 99999`}
            transform={`rotate(${(270 - arc/2)} ${radius} ${radius})`}
          ></circle>
          <circle
            r={radius}
            cx="50%"
            cy="50%"
            fill="none"
            stroke={colors.ok}
            strokeWidth={strokeWidth}
            strokeDasharray={`${okRange * increment * degree} 99999`}
            transform={`rotate(${(270 - arc/2) + boundaryWidth} ${radius} ${radius})`}
          ></circle>
          <circle
            r={radius}
            cx="50%"
            cy="50%"
            fill="none"
            stroke={colors.warning}
            strokeWidth={strokeWidth}
            strokeDasharray={`${warningRange * increment * degree} 99999`}
            transform={`rotate(${((270 - arc/2) + boundaryWidth) + (okRange * increment)} ${radius} ${radius})`}
          ></circle>
          {'trip' in model ? <circle
            r={radius}
            cx="50%"
            cy="50%"
            fill="none"
            stroke={colors.trip}
            strokeWidth={strokeWidth}
            strokeDasharray={`${boundaryWidth * degree} 99999`}
            transform={`rotate(${(270 + arc/2 - boundaryWidth)} ${radius} ${radius})`}
          ></circle> : <></>}
          {'maintain' in model && 'max' in model && model.maintain < model.max ? <circle
            r={radius}
            cx="50%"
            cy="50%"
            fill="none"
            stroke={colors.maintain}
            strokeWidth={strokeWidth * 1.5}
            strokeDasharray={`${(model.max - model.maintain) * increment * degree} 99999`}
            transform={`rotate(${((270 - arc/2) + boundaryWidth) + ((model.maintain - model.low) * increment)} ${radius} ${radius})`}
          ></circle> : <></>}
        </> : <></>}
        { /* / */}

        {/* Needle */}
{model.high && model.trip && model.current != null && !Number.isNaN(model.current) ? <circle
          r={radius}
          cx="50%"
          cy="50%"
          fill="none"
          stroke={colors.needle}
          strokeWidth={Math.max((size / 4), 36)}
          strokeDasharray={`5 99999`}
          transform={`rotate(${currentValue() || (270 - arc/2)} ${radius} ${radius})`}
        ></circle> : <></>}
        {/* / */}
      </svg>
      <div className="unit" style={{top: size * 0.2, fontSize: `${size/10}px`}}>
        {unit ? unit : <>&ndash;</>}
      </div>
      <div className="value" style={{lineHeight: `${size}px`, fontSize: `${size/3}px`}}>
        {Number.isNaN(model.current) || model.current === undefined || model.current === null ? <>&ndash;</> : <>
          {(model.current + '').split('.')[0]}
          {!Number.isInteger(model.current) ?
            <span>.{(model.current + '').split('.')[1]}</span>
          : <></>}
        </>}
      </div>
      {'power' in model ?
        <div style={{fontSize: `${size/12}px`}} className="power-status">
          {model.power}%
        </div>
      : <></>}
    </div>
  );
}

export default Gauge;
